import { render, staticRenderFns } from "./bladeMagazineDataReport.vue?vue&type=template&id=ef2db56e&scoped=true"
import script from "./bladeMagazineDataReport.vue?vue&type=script&lang=js"
export * from "./bladeMagazineDataReport.vue?vue&type=script&lang=js"
import style0 from "./bladeMagazineDataReport.vue?vue&type=style&index=0&id=ef2db56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2db56e",
  null
  
)

export default component.exports